import axios from "axios";

export const axiosSetup = function () {
    axios.defaults.baseURL = "https://api.bpsgaushala.in/api"
    // addtional configuation goes here
}